// extracted by mini-css-extract-plugin
export default {"wrap":"BI-z","subtitle":"CI-z","contentWrap":"DI-z","imgWrap":"EI-z","heading":"FI-z","copy":"GI-z"};